var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"smvp-viewers-count-control"},[_c('badge',{staticClass:"smvp-viewer-count-box"},[_c('icon',{staticClass:"smvp-toggle",attrs:{"name":"eye"}}),_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.count))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }